<app-breadcrumb [home]="home" [items]="breadcrumbs()" />

@if (state.loading()) {
  <app-loading />
} @else if (state.contract(); as contract) {
  <!-- Barra compacta (opção B aprovada em 19/10/2026, protótipo editor-da-minuta-barra-de-acoes): uma linha
       com voltar, identidade, consultas em ícone e, à direita, só o que muda o documento. -->
  <header class="contract-editor__bar">
    <app-button
      icon="pi pi-arrow-left"
      theme="white"
      size="medium"
      [noMargin]="true"
      ariaLabel="Voltar para o parceiro"
      pTooltip="Voltar para o parceiro"
      tooltipPosition="bottom"
      (sendButtonClick)="backToPartner()" />

    <div class="contract-editor__identity">
      <div class="contract-editor__title-row">
        @if (editingTitle() && !locked()) {
          <div class="contract-editor__title-field">
            <app-input
              placeholder="Ex.: Contrato de Parceria Comercial - Parceira"
              [formControl]="state.titleControl"
              [maxLength]="300" />
          </div>
          <app-button
            icon="pi pi-check"
            [text]="true"
            [pureIcon]="true"
            ariaLabel="Concluir o título"
            pTooltip="Concluir o título (o texto é gravado no Salvar)"
            tooltipPosition="bottom"
            (sendButtonClick)="editingTitle.set(false)" />
        } @else {
          <h1 class="contract-editor__title-text" [title]="state.titleControl.value">
            {{ state.titleControl.value || 'Contrato sem título' }}
          </h1>
          @if (!locked()) {
            <app-button
              icon="pi pi-pencil"
              [text]="true"
              [pureIcon]="true"
              ariaLabel="Renomear o contrato"
              pTooltip="Renomear o contrato"
              tooltipPosition="bottom"
              (sendButtonClick)="editingTitle.set(true)" />
          }
        }
        <span
          class="contract-editor__status"
          [class.contract-editor__status--finalized]="state.isFinalized()">
          <i [class]="state.isFinalized() ? 'pi pi-lock' : 'pi pi-pencil'"></i>
          {{ statusLabel() }}
        </span>
      </div>
      <p class="contract-editor__meta">
        {{ contractNumber() }} · {{ partyTypeLabel(contract.partyType) }} · Modelo v{{
          contract.templateVersion
        }}
        · Data do contrato {{ contract.contractDate | vaultDate }}
      </p>
    </div>

    <div class="contract-editor__tools">
      @if (canEditTextNow()) {
        <!-- Só para quem está na lista de editores do texto (Parametrização › Comercial). -->
        <app-button
          [icon]="state.textMode() ? 'pi pi-eye' : 'pi pi-pencil'"
          [text]="true"
          [pureIcon]="true"
          [selected]="state.textMode()"
          [ariaLabel]="state.textMode() ? 'Voltar para a prévia' : 'Editar texto'"
          [pTooltip]="
            state.textMode()
              ? 'Voltar para a prévia do texto com os dados'
              : 'Editar texto (cláusulas e variáveis)'
          "
          tooltipPosition="bottom"
          (sendButtonClick)="toggleTextMode()" />
      }
      <app-button
        icon="pi pi-history"
        [text]="true"
        [pureIcon]="true"
        [selected]="asidePanel() === 'history'"
        [ariaLabel]="asidePanel() === 'history' ? 'Fechar histórico' : 'Histórico de revisões'"
        [pTooltip]="asidePanel() === 'history' ? 'Fechar histórico' : 'Histórico de revisões'"
        tooltipPosition="bottom"
        (sendButtonClick)="toggleHistory()" />
      <app-button
        icon="pi pi-eye"
        [text]="true"
        [pureIcon]="true"
        ariaLabel="Pré-visualizar"
        pTooltip="Pré-visualizar como sai no PDF"
        tooltipPosition="bottom"
        (sendButtonClick)="openPreview()" />
      @if (canExportPdf()) {
        <app-button
          icon="pi pi-file-pdf"
          [text]="true"
          [pureIcon]="true"
          [isLoading]="state.busy() === 'pdf'"
          [disabled]="!!state.busy()"
          ariaLabel="Baixar PDF"
          pTooltip="Baixar PDF"
          tooltipPosition="bottom"
          (sendButtonClick)="downloadPdf()" />
      }
      @if (canDelete() && !state.isFinalized()) {
        <app-action-menu [items]="moreMenuItems" />
      }
    </div>

    @if ((canUpdate() && !state.isFinalized()) || canFinalize()) {
      <span class="contract-editor__divider" aria-hidden="true"></span>
    }

    <div class="contract-editor__primary">
      @if (canUpdate() && !state.isFinalized()) {
        <span class="contract-editor__save-state" role="status">
          {{ state.dirty() ? 'Alterações não salvas' : 'Tudo salvo' }}
        </span>
        <app-button
          label="Salvar"
          icon="pi pi-check"
          theme="white"
          size="medium"
          [noMargin]="true"
          title="Salvar (Ctrl+S)"
          [isLoading]="state.busy() === 'save'"
          loadingText="Salvando..."
          [disabled]="!canSave()"
          (sendButtonClick)="save()" />
      }

      @if (canFinalize()) {
        @if (state.isFinalized()) {
          <app-button
            label="Reabrir"
            icon="pi pi-lock-open"
            theme="white"
            size="medium"
            [noMargin]="true"
            [isLoading]="state.busy() === 'reopen'"
            [disabled]="!!state.busy()"
            (sendButtonClick)="reopen()" />
        } @else {
          <app-button
            label="Finalizar"
            icon="pi pi-lock"
            size="medium"
            [noMargin]="true"
            [isLoading]="state.busy() === 'finalize'"
            [disabled]="!!state.busy()"
            (sendButtonClick)="confirmFinalize()" />
        }
      }
    </div>
  </header>

  @if (state.isFinalized()) {
    <div class="contract-page__notice contract-page__notice--success" role="status">
      <i class="pi pi-lock"></i>
      <span>
        {{
          contract.finalizedAt
            ? 'Contrato finalizado em ' + (contract.finalizedAt | vaultDateTime) + '.'
            : 'Contrato finalizado.'
        }}
        @if (contract.finalizedByName) {
          Por {{ contract.finalizedByName }}.
        }
        O texto está travado; para mudar, use <strong>Reabrir</strong>.
      </span>
    </div>
  }

  @if (state.unfilledKeys().length) {
    <div class="contract-page__notice contract-page__notice--warn" role="status">
      <i class="pi pi-exclamation-triangle"></i>
      <span>
        <strong>Faltam dados:</strong> {{ unfilledDescription() }}.
        @if (!locked()) {
          Preencha no painel <strong>Dados da parte</strong> e use <strong>Salvar</strong>: o texto
          é atualizado com os dados.
        }
      </span>
    </div>
  }

  @if (outOfDefaultDescription()) {
    <div class="contract-page__notice contract-page__notice--warn" role="status">
      <i class="pi pi-exclamation-circle"></i>
      <span>
        <strong>Valores fora do padrão:</strong> {{ outOfDefaultDescription() }}. O envio vai pedir
        aprovação.
      </span>
    </div>
  }

  @if (!locked() && !state.canEditText()) {
    <p class="contract-editor__text-hint" role="note">
      <i class="pi pi-lock"></i>
      O texto das cláusulas é fixo. Altere os campos em <strong>Dados da parte</strong>.
    </p>
  }

  @if (state.dirty() && !state.textMode() && !locked()) {
    <p class="contract-editor__text-hint" role="note">
      <i class="pi pi-info-circle"></i>
      A prévia mostra o texto salvo. Use <strong>Salvar</strong> para ver as mudanças no texto.
    </p>
  }

  @if (state.textMode()) {
    <div class="contract-page__notice contract-page__notice--info" role="note">
      <i class="pi pi-pencil"></i>
      <span>
        Você está editando o <strong>texto-fonte</strong>. As variáveis
        <code>{{ variableExample }}</code> são trocadas pelos dados da parte ao salvar. Use o botão
        <strong>Variável</strong> para inserir uma.
      </span>
    </div>
  }

  <div class="contract-page__layout" [class.contract-page__layout--with-aside]="!!asidePanel()">
    <section class="contract-page__main">
      <!-- O editor do corpo-fonte fica montado (só escondido) ao voltar para a prévia, para não
           perder o desfazer. As pendências vêm do servidor (texto renderizado), não do editor. -->
      @if (state.canEditText()) {
        <div [class.contract-page__hidden]="!state.textMode()">
          <app-rich-text-editor
            [formControl]="state.sourceBodyControl"
            [variables]="state.variables()"
            [readonly]="!canEditTextNow()" />
        </div>
      }
      <div [class.contract-page__hidden]="state.textMode()">
        <app-rich-text-editor
          [formControl]="state.renderedBodyControl"
          [variables]="state.variables()"
          [readonly]="true" />
      </div>
    </section>

    @if (asidePanel() === 'history') {
      <div class="contract-page__aside">
        <app-partner-contract-revision-history
          [revisions]="state.revisions()"
          [fieldChanges]="state.fieldChanges()"
          [loading]="state.revisionsLoading()"
          [selectedId]="selectedRevisionId()"
          (selectRevision)="openRevision($event)"
          (collapse)="toggleHistory()" />
      </div>
    } @else if (asidePanel() === 'party') {
      <aside class="contract-page__aside contract-editor__party" aria-label="Dados da parte">
        <header class="contract-editor__party-header">
          <div>
            <h3>Dados da parte</h3>
            <p>Preenchem as variáveis do texto.</p>
          </div>
          <button
            type="button"
            class="contract-editor__collapse"
            pTooltip="Recolher painel"
            tooltipPosition="left"
            aria-label="Recolher painel"
            (click)="togglePartyPanel()">
            <i class="pi pi-angle-double-right"></i>
          </button>
        </header>

        <app-partner-contract-party-form
          [form]="state.partyForm"
          layout="single"
          [readonly]="locked()"
          [fieldDefaults]="contract.fieldDefaults ?? null"
          [legatusSignatoryName]="contract.legatusSignatoryName ?? null" />

        @if (!locked()) {
          <div class="contract-editor__refill">
            <app-button
              label="Preencher variáveis pendentes"
              icon="pi pi-sync"
              theme="white"
              [isLoading]="state.busy() === 'refill'"
              loadingText="Preenchendo..."
              [disabled]="!!state.busy() || !state.unfilledKeys().length"
              (sendButtonClick)="refill()" />
            <small>
              Salva o contrato, relê o signatário da Legatus na Parametrização e atualiza o texto
              com os dados acima.
            </small>
          </div>
        }
      </aside>
    } @else {
      <button type="button" class="contract-editor__reopen-panel" (click)="togglePartyPanel()">
        <i class="pi pi-angle-double-left"></i>
        Dados da parte
      </button>
    }
  </div>
}

<app-modal-partner-contract-preview #previewModal (useText)="useRevisionText()" />
